export default __webpack_public_path__ + "5abee7721b82aa2c0edb01315db6a5e1.ogg";